/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { FormControl, FormGroup, FormLabel, styled } from "@mui/material";
import { nameof } from "../../Utils/AnyUtil";
import Tooltip, { TooltipContainerStyle } from "../Tooltip";
import FieldsetModel from "./FieldsetModel";
import FieldsetProps from "./FieldsetProps";

const FieldsetControl = styled(FormControl, {
    shouldForwardProp: prop => prop !== nameof<FieldsetProps>("fullWidth")
})<Pick<FieldsetProps, "fullWidth">>(({ theme, fullWidth }) => ([
    {
        display: "block",
        maxWidth: "30rem",
        width: "calc(100% - 1rem)",
        margin: ".5rem 0 1rem .5rem",
        "& > .Mui-focused": {
            color: theme.palette.text.primary,
        }
    },
    !!fullWidth && {
        maxWidth: "100%",
    }
])) as typeof FormControl;

export const FieldsetLabel = styled(FormLabel)(({ theme }) => ({
    color: `${theme.palette.text.primary} !important`,
    marginBottom: ".3rem",
    fontWeight: "bold",
    "& > .lan-tooltip__container": {
        display: "inline-block",
        marginLeft: ".5rem"
    }
})) as typeof FormLabel;

export default function Fieldset(props: FieldsetProps) {
    const vm = new FieldsetModel(props);
    return (
        <FieldsetControl
            variant="standard"
            component="fieldset"
            className={props.className}
            fullWidth={props.fullWidth}
            sx={props.sx}
        >
            <FieldsetLabel component="legend">
                {vm.caption}
                {props.tooltip && (
                    <Tooltip
                        title={props.tooltip}
                        containerStyle={TooltipContainerStyle.inline}
                    />
                )}
            </FieldsetLabel>
            <FormGroup sx={{ flexWrap: "nowrap" }}>{vm.children}</FormGroup>
        </FieldsetControl>
    );
}
